import PropTypes from "prop-types";
import React from "react";
/**
 *
 * @param {object} props
 * @param {{ name: string, Icon: JSX.Element | (() => JSX.Element), url: string, disabled?: boolean }[]} props.items
 * @param {(props: { children: any, to: string }) => JSX.Element} props.Link
 * @param {(url: string) => boolean} props.isUrlActive
 * @returns
 */

export const SideBar = ({
  items,
  Link,
  isUrlActive
}) => {
  const ConditionalLink = ({
    children,
    to
  }) => to ? /*#__PURE__*/React.createElement(Link, {
    to: to
  }, children) : children;

  ConditionalLink.propTypes = {
    children: PropTypes.node,
    to: PropTypes.string
  };

  const renderSideBar = () => {
    const selectedClassNames = "border-solid bg-en-yellow-300 border-en-yellow-700 border-l-8";
    return items.map(page => {
      return /*#__PURE__*/React.createElement(ConditionalLink, {
        key: page.name,
        to: !page.disabled ? page.url : null
      }, /*#__PURE__*/React.createElement("div", {
        className: `py-2 my-2 ${isUrlActive(page.url) ? selectedClassNames : ""} flex items-center  ${page.disabled ? "text-gray-400" : ""}`
      }, page.Icon ? typeof page.Icon === "function" ? /*#__PURE__*/React.createElement(page.Icon, null) : page.Icon : null, /*#__PURE__*/React.createElement("label", {
        className: "mr-4 cursor-pointer px-4"
      }, page.name.split(" ").map((word, index) => /*#__PURE__*/React.createElement("div", {
        key: `${page.name}${index}`
      }, word)))));
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, renderSideBar());
};
SideBar.propTypes = {
  items: PropTypes.array,
  Link: PropTypes.func,
  isUrlActive: PropTypes.func
};
export default SideBar;